import { SET_MAP_LOCATION } from 'src/store/actions/types';

/**
 * commits the id to the store using the SET_MAP_LOCATION action type
 */
export const setMapLocation = ({ commit }, {latitude, longitude, address1, address2, city, addressState, zip}) => 
commit(SET_MAP_LOCATION, {latitude: latitude, longitude: longitude, address1: address1, address2: address2, 
    city: city, addressState: addressState, zip: zip});
